import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../../types/configColumns2";
import { momentDtoToLocalStringByCulture } from "../../../aplUtils/dateHelper";
import { WorkorderManagementBob } from "../../../types/workorderManagementBob";
import { Culture } from "../../../types/culture";
import React from "react";

const getWorkorderManagementBobPaneColumns = (
    culture: Culture,
    selectedItems: WorkorderManagementBob[],
    saveBob: (workorderBob: WorkorderManagementBob) => void,
    deleteBob: (workorderBob: WorkorderManagementBob) => void,
    changeBobPriority: (workorderBob: WorkorderManagementBob, offset: number) => void
): ConfigColumns2[] => {
    const isSelected = (workorderBob: WorkorderManagementBob) => {
        return selectedItems.some(item => item.woBobId === workorderBob.woBobId);
    };

    return [
        { data: "woBobId", visible: false, width: "0%", title: "woBobId" },
        { data: "siteId", visible: false, width: "0%", title: "siteId" },
        {
            data: "batch",
            className: "nowrap",
            width: "20%",
            title: "batch",
            render: function (data: WorkorderManagementBob, type: ColumnFilterOrDisplayType | undefined) {
                if (type === "display") {
                    return (
                        <input
                            type="number"
                            value={data.batch}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // updateBatchState({ ...data, batch: e.currentTarget.valueAsNumber });
                            }}
                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                e.stopPropagation();
                            }}
                            name="batch"
                            className="form-control form-control-sm"
                            readOnly={true}
                        />
                    );
                }
                return data.batch.toString();
            }
        },
        {
            data: "materialSapCode",
            className: "nowrap",
            width: "20%",
            title: "material",
            render: function (data: WorkorderManagementBob, type: ColumnFilterOrDisplayType | undefined) {
                if (type === "display") {
                    return (
                        <input
                            type="number"
                            value={data.materialSapCode}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // updateBatchState({ ...data, batch: e.currentTarget.valueAsNumber });
                            }}
                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                e.stopPropagation();
                            }}
                            name="materialSapCode"
                            className="form-control form-control-sm"
                            readOnly={true}
                        />
                    );
                }
                return data.materialSapCode.toString();
            }
        },
        {
            data: "shiftStart",
            className: "nowrap",
            width: "25%",
            render: function (data: WorkorderManagementBob, type: ColumnFilterOrDisplayType | undefined) {
                return type === "sort" ? (
                    data.shiftStart
                ) : (
                    <input
                        type="text"
                        value={momentDtoToLocalStringByCulture(data.shiftStart, culture)}
                        onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                            e.stopPropagation();
                        }}
                        name="shiftStart"
                        className="form-control form-control-sm"
                        readOnly={true}
                    />
                );
            },
            title: "batchStart"
        },
        {
            data: "priority",
            className: "nowrap",
            width: "45%",
            title: "priority",
            render: function (data: WorkorderManagementBob, type: ColumnFilterOrDisplayType | undefined) {
                if (type === "display") {
                    return (
                        <React.Fragment>
                            <div className="input-group">
                                <input
                                    type="number"
                                    value={data.priority}
                                    onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                        e.stopPropagation();
                                    }}
                                    name="priority"
                                    className="form-control form-control-sm"
                                    readOnly={true}
                                />
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-sm btn-primary"
                                        disabled={!isSelected(data)}
                                        onClick={e => {
                                            e.stopPropagation();
                                            changeBobPriority(data, -1);
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-arrow-up"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                                            />
                                        </svg>
                                    </button>
                                    <button
                                        className="btn btn-sm btn-primary"
                                        disabled={!isSelected(data)}
                                        onClick={e => {
                                            e.stopPropagation();
                                            changeBobPriority(data, +1);
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-arrow-down"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                }
                return data.priority.toString();
            }
        },
        {
            data: "edit",
            className: "nowrap",
            width: "5%",
            render: function (data: WorkorderManagementBob, type: ColumnFilterOrDisplayType | undefined) {
                if (type === "display") {
                    if (!isSelected(data))
                        return (
                            <button className="btn btn-sm">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil-square"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                    <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                    ></path>
                                </svg>
                            </button>
                        );
                    return (
                        <button
                            className="btn btn-sm"
                            onClick={e => {
                                e.stopPropagation();
                                if (!isSelected(data)) return;
                                // alert(`save ${data.workOrderBatchId}`);
                                saveBob(data);
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="green"
                                className="bi bi-check-square"
                                viewBox="0 0 16 16"
                            >
                                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"></path>
                                <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"></path>
                            </svg>
                        </button>
                    );
                }
                return "";
            },
            title: "edit"
        },
        {
            data: "delete",
            className: "nowrap",
            width: "5%",
            render: function (data: WorkorderManagementBob, type: ColumnFilterOrDisplayType | undefined) {
                if (type === "display") {
                    if (!isSelected(data))
                        return (
                            <button
                                className="btn btn-sm"
                                disabled={true}
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill={isSelected(data) ? "red" : "lightgray"}
                                    className="bi bi-x-square"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"></path>
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                                </svg>
                            </button>
                        );

                    return (
                        <button
                            className="btn btn-sm"
                            onClick={e => {
                                e.stopPropagation();
                                if (!isSelected(data)) return;
                                deleteBob(data);
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill={isSelected(data) ? "red" : "lightgray"}
                                className="bi bi-x-square"
                                viewBox="0 0 16 16"
                            >
                                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"></path>
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                            </svg>
                        </button>
                    );
                }
                return "";
            },
            title: "delete"
        }
    ];
};

export { getWorkorderManagementBobPaneColumns };
